import Loan from "./Loan.jsx";

export default Loan;
